document.addEventListener("DOMContentLoaded", function(){
    //Get the overlay
    const menuOverlay = document.querySelector('.menu-overlay');
    menuOverlay.addEventListener('click',function (event){
        const signInButton = document.getElementById('signInDesktop');
        if(signInButton.getAttribute('aria-expanded') === 'true') signInButton.click();
    },false);
    var togglesOpen = 0;

    //Get the Nav Links that trigger showing and hidding the overlays in Desktop
    document.querySelectorAll('.nav-link.dropdown-toggle').forEach(function(menuToggle){
        menuToggle.addEventListener('shown.bs.dropdown', function () {
            togglesOpen++;
            evalTogglesOpen();
        });

        menuToggle.addEventListener('hide.bs.dropdown', function () {
            togglesOpen--;
            evalTogglesOpen();
        });
    });

    //Get the mobile menu toggler (#navContent) and sign In collapses that triggers show and hiding the overlay
    document.querySelectorAll('#signInDesktopCollapse, #signInMobileCollapse, #navContent').forEach( function (collapse){
        collapse.addEventListener('show.bs.collapse', function () {
            togglesOpen++;
            evalTogglesOpen();
        });
        collapse.addEventListener('hide.bs.collapse', function () {
            togglesOpen--;
            evalTogglesOpen();
        });
    });

    //Desktop - When opening a dropdown when another is open, the order in which Bootstrap runs is odd. We need this helper to handle this.
    function evalTogglesOpen(){
        if(togglesOpen > 0){
            menuOverlay.classList.add('show');
        }else{
            menuOverlay.classList.remove('show');
        }
    }
});